/**
 * Status of a run which is running on the background.
 *
 * A batched run is an artifial representation of a run which is
 * generated by clicking the commit button. These status are not a property of
 * a run. Instead, they represent an interim state which describes what is
 * currently happening to a run.
 */
enum BatchedRunStatus {
  NONE = "none",
  COMMITTING = "committing",
  RUNNING = "running",
  CANCELLING = "cancelling",
  UPLOADING = "uploading",
  COMPLETE = "complete",
  CANCELLED = "cancelled",
  ERROR = "error",
  UPLOADING_FILES = "uploading files",
}

export default BatchedRunStatus;
